import axios from "axios";
import { toastSuccess } from "@/lib/toast";

export async function subscribe(email) {
  try {
    const response = await axios.post("/api/subscribe", { email });
    toastSuccess(response?.data?.message);
    return response;
  } catch (err) {
    console.log(err);
  }
}